import axios from 'axios';
import Cookies from 'js-cookie';

import { API_URL } from 'constants'

export function getItem(id) {
  return axios.get(`${API_URL}/api/v1/items/${id}.json`, { withCredentials: true })
    .then(response => response.data.data)
    .catch((response) => {
      console.log(response);

      return null;
    })
}

export function getItems() {
  return axios.get(`${API_URL}/api/v1/items.json`, { withCredentials: true })
    .then(response => response.data.data)
    .catch((response) => {
      console.log(response);

      return [];
    })
}

export function createItem(params) {
  const token = Cookies.get('csrf_token');

  return axios.post(`${API_URL}/api/v1/items.json`, params, { headers: { 'X-CSRF-TOKEN': token, withCredentials: true }})
    .then(response => response.data.data)
    .catch((response) => {
      console.log(response);
    })
}
